import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Soft "turn the next page" prompt at the end of each chapter.
 */
export default function NextPage({ to, label, onClick }) {
  return (
    <div className="flex flex-col items-center mt-20 mb-10">
      <p className="font-script text-2xl text-[#4B3A2F] mb-3">
        turn the page
      </p>
      <Link
        to={to}
        onClick={onClick}
        data-testid={`next-page-${to.replace(/\//g, "") || "home"}`}
        className="btn-pasture group"
      >
        <span>{label}</span>
        <ArrowRight
          size={18}
          className="transition-transform duration-700 group-hover:translate-x-1"
        />
      </Link>
    </div>
  );
}
